import React, { useEffect, useState } from "react";
import { Modal, Row } from "rsuite";
import { EPTable } from "../../common/controls/table";
import { CommonConstants } from "../../common/utils/CommonConstants";
import { AxiosResponse } from "axios";
import { axiosGet, axiosGetParams } from "../../common/utils/helper";
import { CandidateRequestHistory } from "../../common/utils/api";

interface Props {
  openViewCandidateHistory: boolean;
  setOpenViewCandidateHistory: React.Dispatch<React.SetStateAction<boolean>>;
  data: any;
  dataKey: any;
}

const CandidateRequestModal = (props: Props) => {
  const {
    data,
    setOpenViewCandidateHistory,
    openViewCandidateHistory,
    dataKey,
  } = props;
  const [candidateRequestData, setCandidateRequestData] = useState<any>({});
  const id = data.RequirementId;

  // Status label
  const getStatusLabel = (key: any) => {
    switch (key) {
      case "NoOfInterviewSchedule":
        return "Schedule Date";
      case "NoOfShortListCandidate":
        return "ShortList Date";
      case "RejectedCandidate":
        return "Rejected Date";  
      case "OfferedCandidate":
        return "Offered Date"
      case "JoinedCandidate":
        return "Joined Date"    
      default:
        return "Joining Date";
    }
  };

  //Status key
  const getStatusKey = (key: any) => {
    switch(key){
      case "OfferedCandidate":
        return "CandidateOfferedDate";
       case "JoinedCandidate":
        return "CandidateJoiningDate" 
       default: 
        return "StatusDate" 
    }
  }

  //model title change
  const getModelkey = (key: any) => {
    switch(key) {
      case "NoOfInterviewSchedule":
        return "Schedule Candidates";
      case "NoOfShortListCandidate":
        return "ShortList Candidates";
      case "RejectedCandidate":
        return "Rejected Candidates";  
      case "OfferedCandidate":
        return "Offered Candidates"
      case "JoinedCandidate":
        return "Joined Candidates"    
      default:
        return "Candidate History";
    }
  }

  const tableColumns: any = [
    {
      key: "CandidateName",
      label: "Candidate Name",
      resizable: true,
      width: 580,
    },

    {
      key: getStatusKey(dataKey),
      // key: "StatusDate",
      label: getStatusLabel(dataKey),
      resizable: true,
      width: 180,
    },
  ];

  useEffect(() => {
    getCandidateRequestDetail(CandidateRequestHistory);
  }, []);

  async function getCandidateRequestDetail(reqUrl: string) {
    try {
      const response = (await axiosGetParams(
        `${reqUrl}/${id}`
      )) as AxiosResponse;
      const statusResponse = response.data.data.data;

      const statusList: {
        NoOfInterviewSchedule: string[];
        RejectedCandidate: string[];
        NoOfShortListCandidate: string[];
        OfferedCandidate: string[];
        JoinedCandidate: string[];
      } = {
        NoOfInterviewSchedule: ["Interview Scheduled"],
        RejectedCandidate: ["Rejected"],
        NoOfShortListCandidate: [
          "Needs Second Opinion",
          "Can be considered",
          "Suitable",
        ],
        OfferedCandidate: ["Offered", "Accepted", "Declined", "Joined", "Drop Out"],
        JoinedCandidate: ["Joined"],
      };

      // Assuming dataKey is a valid key in the statusList object
      const filterStatus = statusResponse.filter((item: any) => {
        const keyArray = (statusList as any)[dataKey]; // Access the array associated with dataKey
        const includesStatus = keyArray?.includes(item.StatusName); // Check if item.StatusName is in the array


        return includesStatus;
      });

      setCandidateRequestData(filterStatus);
    } catch (error) {
      console.error("Error fetching candidate request detail:", error);
    }
  }

  function closeModal() {
    setOpenViewCandidateHistory(false);
  }
  return (
    <>
      <Modal
        open={openViewCandidateHistory}
        onClose={closeModal}
        className="modal-lg"
        size="lg"
      >
        <Modal.Header>
          <Modal.Title>{getModelkey(dataKey)}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <EPTable
              columns={tableColumns}
              rowHeight={40}
              listName="manageRequestHistory"
              data={candidateRequestData}
            />
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default CandidateRequestModal;
